export default "__VITE_ASSET__$TgFprei__"